import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { SectionCard } from '../../components/card'
import { Separator } from '../../components/separator'
import { Stepper } from '../../components/stepper'
import ReasonSegments from './segments/reason-segments'
import { useNavigate } from 'react-router-dom'
import { ApplicationStep1, HouseholdFormData, ReasonFormData } from '../../models/classes/ApplicationStep1.class'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { stepperItems } from '../../utils/shared-dropdown'
import ApplicationCooLayout from '../../layout/application-coo-layout'
import { IErrors, useForm } from '../../hooks/use-form'
import { validateHoldingOwnerOccupier, validateHousehold, validateReason } from '../../utils/validator'
import { updateStructureStatus } from '../../../src/redux/slices/authentication-slice';
import { StructureStatusEnum } from '../../models/enum/structure-status.enum'

import { P2Alert, P2Button, P2ButtonGroup, P2TextDescription } from 'react-bootstrap-common-script'
import { MyInfo, MyInfoWithDOD } from '../../models/polymer/MyInfo.model'
import { Owner } from '../../models/polymer/Owner.model'
import HouseholdStructure from './segments/household-structure'
import ReasonDropdown from '../../components/HOC/reason-dropdown'
import { checkNeedBypass35YearsOld, checkProposedHouseholdHasOwner, convertRoleToStructureStatus, step1SchemeCheckingEligibility } from '../../utils/form-helper'
import { updateFormData as updateFormDataStart } from '../../redux/slices/application-start-slice'
import { updateFormData } from '../../redux/slices/application-step-1-slice'
import { updateFormData as updateFormDataStep2 } from '../../redux/slices/application-step-2-slice'
import { updateFormData as updateFormDataStep3 } from '../../redux/slices/application-step-3-slice'
import { updateFormData as updateFormDataStep4 } from '../../redux/slices/application-step-4-slice'
import { updateFormData as updateFormDataStep5 } from '../../redux/slices/application-step-5-slice'
import { Occupier } from '../../models/polymer/Occupier.model'
import { HoldingFormData, InitIncomingToHoldingFormData } from '../../models/polymer/HoldingFormData.model'
import { ReasonEnum } from '../../models/enum/reason.enum'
import { OwnershipReasonEnum } from '../../models/enum/ownership-reason.enum'
import RadioGroup from '../../components/form/grouped/radio/radio-group'
import { Radio_Has_Property } from '../../utils/shared-radio'
import { TextSubheader } from '../../components/text/text-subheader'
import useSaveDraft from '../../hooks/use-save-draft'
import { InfoCard } from '../../components/info'
import DangerCircle from '../../assets/svg/danger-circle'
import { HoldingTypeEnum } from '../../models/enum/holding-type.enum'
import { updateStageAStep1 } from '../../redux/slices/completed-steps-slice'
import { ResidentialStatusEnum } from '../../models/enum/residential-status.enum'
import useIdleSaveDraft from '../../hooks/use-idle-save-draft'
import { Eligibility } from '../../models/polymer/Eligibility.model'
import { ChangeOwnershipReasonCode } from '../../utils/code-converter'
import { PolymerAxios } from '../../utils/axios'
import LeavingPageModal from './leaving-page-modal'
import { API_ApplicationRemove, API_CheckEligibility,API_EligibilityDebugLog } from '../../utils/api'
import {useInitialWindowScrollTo} from '../../hooks/use-initial-window-scroll-to'
import SaveDraftAlert from '../../components/HOC/stage-a-form/save-draft-alert'
import { setLeavePageModalOpen, setNavigatingValue } from '../../redux/slices/leave-page-slice'
import BackConfirmationModal from './back-confirmation-modal'
import { setBackTriggered, setLastBackTriggeredTime } from '../../redux/slices/back-triggered-slice'
import moment from 'moment'
import { MopCheckStatusEnum } from '../../models/enum/mop-check-status.enum'
import { PolymerCrypto } from '../../utils/encryptor'
import { Helpers } from '../../utils/helper'
import { ApplicationStep2 } from '../../models/classes/ApplicationStep2.class'
import { ApplicationStep3 } from '../../models/classes/ApplicationStep3.class'
import { ApplicationStep4 } from '../../models/classes/ApplicationStep4.class'
import { LoanTypeEnum } from '../../models/enum/loan-type.enum'
import { cloneDeep } from 'lodash'
import { ApplicationStep5 } from '../../models/classes/ApplicationStep5.class'
import { MaritalStatusEnum } from '../../models/enum/marital-status.enum'
import { ApplicationStart } from '../../models/classes/ApplicationStart.class'
import { RegistrarSelectionModal, RegistrarSelectionModalHandle } from './review-endorse/registrar-selection-modal'
let activeStep = 1;

function ApplicationCOOStep1() {

  const AppDispatch = useAppDispatch();
  const navigate = useNavigate();
  const { performSaveDraft, performSaveDraftManual } = useSaveDraft();
   useIdleSaveDraft(() => {saveDraft(false)});

  const [isCheckingEligibility, setIsCheckingEligibility] = useState<boolean>(false);
  const [isEligible, setIsEligible] = useState<boolean | undefined>(undefined);
  const [eligibleMsg, setIsEligibleMsg] = useState<any>('');
  const [saveDraftSuccess, setSaveDraftSuccess] = useState<boolean>(false);
  const [backConfirmationModalOpen, setBackConfirmationModalOpen] = useState<boolean>(false);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const retrieveFromMyInfo = useAppSelector(state => state.auth.AuthenticationSlice.retrieveFromMyInfo);
  const currentOwnerMyInfoData = useAppSelector(state => state.auth.AuthenticationSlice.myInfoData);
  const startApplicationFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const application1FormData = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const application2FormData = useAppSelector(state => state.app.ApplicationStep2Slice.formData);
  const applicationStep4FormData = useAppSelector(state => state.app.ApplicationStep4Slice.formData);
  const applicationId = useAppSelector(state => state.app.ApplicationIdSlice.applicationId);
  const declaration = useAppSelector(state => state.app.CompletedStepsSlice.stage_a.declaration);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const backTriggeredSlice = useAppSelector(state => state.app.BackTriggeredSlice);
  const currentHoldingType = useAppSelector(state => state.app.ApplicationStartSlice.formData.selected_hdb_property?.holding_type);
  const hdbRef = useAppSelector(state => state.app.ApplicationStartSlice.formData.selected_hdb_property?.hdb_ref);
  const [isPropertyAdmin ] = useState<boolean>(false);
  const [isSavingDraft, setIsSavingDraft] = useState<boolean>(false);
 
  const { values: reasonValues, errors: reasonErrors, formValid: reasonFormValid, setFormValue: reasonSetFormValue, setAdditionalData:setReasonAdditionalData }: { handleChange: any, values: ReasonFormData, errors: IErrors, formValid: boolean, setFormValue: (update: any) => void, setAdditionalData: any} = useForm(new ReasonFormData(), () => { }, validateReason);
  const { values: householdFormValues, errors: householdFormErrors, formValid: householdFormValid, setFormValue: householdSetFormValue }: { handleChange: any, values: HouseholdFormData, errors: IErrors, formValid: boolean, setFormValue: (update: any) => void } = useForm(new HouseholdFormData(), () => { }, validateHousehold, reasonValues);
  const { values: holdingFormValues, errors: holdingFormErrors , formValid:holdingFormValid, setFormValue: holdingSetFormValue }: {values: HoldingFormData, handleChange: any,  errors: any, formValid: boolean, setFormValue: (update: any) => void } = useForm(new HoldingFormData(), () => { }, validateHoldingOwnerOccupier);
  
  const [ forceError, setForceError ] = useState<boolean>(false);

  const modalRef = useRef<RegistrarSelectionModalHandle>(null)
  useInitialWindowScrollTo();

  useEffect(()=>{
    if(!declaration){
      navigate('/application-coo/stage-a/declaration')
    }
  },[declaration, navigate])
  
  const isValueChanged = useMemo(() => {
    let oldApplicationForm = new ApplicationStep1({ reason: new ReasonFormData({...application1FormData.reason}), household: new HouseholdFormData({...application1FormData.household}) });
    let newApplicationForm = new ApplicationStep1({ reason: new ReasonFormData({...reasonValues}), household: new HouseholdFormData({...householdFormValues}) });

    return Helpers.checkIsValueChanged(oldApplicationForm.reason, newApplicationForm.reason) || Helpers.checkIsValueChanged(oldApplicationForm.household, newApplicationForm.household)
  }, [application1FormData, reasonValues, householdFormValues])

  // Reset eligibility when user ACTUALLY changes form values
  // This compares against saved data (application1FormData), not just object references.
  // After saveDraft, application1FormData matches current values → isValueChanged = false
  // When user edits form, values differ from saved → isValueChanged = true → reset eligibility
  useEffect(() => {
    if (isValueChanged) {
      setIsEligible(undefined);
      setIsEligibleMsg('');
    }
  }, [isValueChanged])

  const loginUserStructureStatus = useMemo(() => {
    const checkOriginalOwner = householdFormValues.owners.find(
      (item) => item.myinfo.uinfin === loginUser.uinfin
    );

    const checkRetainingOwner = householdFormValues.incoming_owners.find(
      (item) => item.myinfo.uinfin === loginUser.uinfin
    );

    if(checkOriginalOwner && checkRetainingOwner){
      return StructureStatusEnum.retaining;
    }else if(checkOriginalOwner && !checkRetainingOwner){
      return StructureStatusEnum.outgoing;
    }else{
      return StructureStatusEnum.incoming;
    }

  }, [loginUser, householdFormValues]);

  const hasExecutorAdministrator = useMemo(()=>{
    return startApplicationFormData?.selected_hdb_property?.additional_roles.some(e=>{
      const roleStructureStatus = convertRoleToStructureStatus(e.role_name);
      return roleStructureStatus === StructureStatusEnum.executor || roleStructureStatus === StructureStatusEnum.administrator
    })
  },[startApplicationFormData?.selected_hdb_property?.additional_roles])

  useEffect(() => {
    AppDispatch(updateStructureStatus(loginUserStructureStatus));
  }, [loginUserStructureStatus])

  // NOTE: Removed auto-reset of forceError on form value changes.
  // forceError is now only reset at the START of eligibilityChecking.

  /** 
   * THIS IS FOR INITIALIZATION OF FORM DATA
   * Note: Initialize results if there is any init data;
  */
  const isInitializedRef = useRef(false);
  useEffect(() => {
    // Only reset eligibility on FIRST initialization, not on every Redux update
    // (saveDraft triggers Redux updates which would wipe out the eligibility result)
    if (isInitializedRef.current) {
      return;
    }
    isInitializedRef.current = true;
    
    let timeoutID: number;
    timeoutID = window.setTimeout(() => {
      setIsEligible(undefined);
      setIsEligibleMsg('');
      if (application1FormData && (application1FormData.reason.reason || application1FormData.household.incoming_owners?.length > 0)) {
        reasonSetFormValue({...application1FormData?.reason});
        householdSetFormValue({...application1FormData?.household});
        let initHoldingFormData = new InitIncomingToHoldingFormData(application1FormData?.household);
        holdingSetFormValue(new HoldingFormData(initHoldingFormData.generateHoldingForm(startApplicationFormData, holdingFormValues)));
      }
      else if(startApplicationFormData.selected_hdb_property?.owners){
        // NOTE: When no initial data from slice;
        // Process owners and occupiers from the startApplicationFormData
        let tempOwners:Owner[] = [];
        let tempOccupier:Occupier[] = [];
        //--PROCESS CURRENT OWNERS AND OCCUPIERS EXISTING HDB
        startApplicationFormData?.selected_hdb_property?.owners?.forEach((item: MyInfoWithDOD,_index:number) => {
          tempOwners.push(new Owner({...item, myinfo: new MyInfo(item), live_status: item.live_status, dod: item.dod, role_name:item.role_name}))
        })
        startApplicationFormData?.selected_hdb_property?.occupiers?.forEach((item: MyInfo,_index:number) => {
          tempOccupier.push(new Occupier({myinfo: new MyInfo(item)}))
        })
        //-------
        reasonSetFormValue(new ReasonFormData());
        holdingSetFormValue(new HoldingFormData());
        householdSetFormValue(new HouseholdFormData({owners: [...tempOwners], occupiers: [...tempOccupier]}));

        if (isPropertyAdmin && currentHoldingType === HoldingTypeEnum.tenancy_in_common) {
          reasonSetFormValue({
            reason: "demise_of_current_owner",
            change_ownership_reason: OwnershipReasonEnum.demise_of_current_owner,
          });
        }
      }
    }, 200);

    return () => {
      clearTimeout(timeoutID);
    }
  }, [application1FormData, startApplicationFormData])


  
  const householdLogic = useMemo(()=>{
    const isIncomingHoldingSame = holdingFormValues.holding_occupiers?.length === householdFormValues?.incoming_occupiers?.length && holdingFormValues.holding_owners?.length === householdFormValues?.incoming_owners?.length;
    return checkProposedHouseholdHasOwner(householdFormValues).pass && isIncomingHoldingSame;
  },[holdingFormValues, householdFormValues])

  const allSprHasPropertyLogic = useMemo((): boolean => {
    const residentialStatus = householdFormValues.incoming_owners.map(item => item.myinfo.residential_status);
    if(residentialStatus.length > 0 && residentialStatus.filter(item => item === ResidentialStatusEnum.pr).length === residentialStatus.length && householdFormValues.check_has_private_property){
        return true;
    }

    return false;
  }, [householdFormValues]);

  const isBtnValid = useMemo((): boolean => {
    return reasonFormValid && householdFormValid && holdingFormValid && householdLogic && !allSprHasPropertyLogic;
  }, [reasonFormValid,householdFormValid,holdingFormValid, householdLogic, allSprHasPropertyLogic]);


  const financialHardshipAdditionalChecking = useMemo((): number => {
    // Outcome codes consumed by the reason form / validator:
    //   NORMAL          -> continue with the standard financial hardship flow
    //   SHOW_HOUSEHOLD  -> skip ahead and directly show the household section
    //   REJECT          -> applicant does not qualify, block submission
    const NORMAL = 1;
    const SHOW_HOUSEHOLD = 2;
    const REJECT = 99;

    // hasOutstandingFee: derived in Polymer BE from the PFS response (true/false).
    const hasOutstandingFee = startApplicationFormData.has_outstanding_loan || false;

    // numsArrearsMonths: number of months in arrears, sourced from SMS.
    const numsArrearsMonths =
      startApplicationFormData.selected_hdb_property?.financing_info.num_months_in_arrears_or_advance || 0;

    // Financial hardship is indicated when the loan is 3+ months in arrears
    // or there is an outstanding fee.
    const hasFinancialHardship = parseFloat(String(numsArrearsMonths)) >= 3 || hasOutstandingFee;

    const currentLoanType =
      startApplicationFormData.selected_hdb_property?.financing_info.current_loan_type;
    const isHdbOrNoLoan =
      currentLoanType === LoanTypeEnum.hdb_loan || currentLoanType === LoanTypeEnum.no_loan;

    // For HDB / No loan: reject only when there is no sign of financial hardship,
    // i.e. PFS returns false AND arrears from SMS are under 3 months.
    //
    // IMPORTANT: An HDB loan with a $0 balance is deemed "No loan" by the system,
    // not an outstanding loan. Both cases are therefore handled by this branch.
    if (isHdbOrNoLoan) {
      return hasFinancialHardship ? SHOW_HOUSEHOLD : REJECT;
    }

    // For other loan types (e.g. bank): an outstanding fee jumps straight to the
    // household section, otherwise proceed with the normal flow.
    return hasOutstandingFee ? SHOW_HOUSEHOLD : NORMAL;
  }, [startApplicationFormData.has_outstanding_loan, startApplicationFormData.selected_hdb_property]);

  useEffect(()=>{
    setReasonAdditionalData({financialHardshipAdditionalChecking:financialHardshipAdditionalChecking});
  },[financialHardshipAdditionalChecking, setReasonAdditionalData]);
  
  const ownerStructureFormChecking = () => {
    switch (reasonValues?.reason) {
      //reason = Moving out
      case ReasonEnum.owner_moving_out_reason_value:
        if(reasonValues.change_ownership_reason === OwnershipReasonEnum.moving_out_others){
          //change_ownership_reason = moving out due to other reason, then check MOP status is true
          return reasonFormValid && (reasonValues.check_mop_status !== "N");
        }
        //change_ownership_reason = moving out due to marriage
        return reasonFormValid; 
      case ReasonEnum.loss_of_citizenship_reason_value:
        return reasonFormValid;
      case ReasonEnum.financial_circumstances_reason_value:
        return reasonFormValid && reasonValues.check_loan_status === true && financialHardshipAdditionalChecking !== 99;
      case ReasonEnum.marital_status_reason_value:
      case ReasonEnum.demise_current_owner_reason_value:
      case ReasonEnum.health_reasons_reason_value:
        return reasonFormValid;
      default:
        return false;
    }
  }

  const getOwnersAndOccupiersForCheck = useCallback(() => {
    const allOwners = householdFormValues.incoming_owners.concat(householdFormValues.owners);
    const owners: Owner[] = [];
    const allowBypass35YearsOldCheck = checkNeedBypass35YearsOld(householdFormValues, reasonValues);
    for(const owner of allOwners){
       if(!owners.some(item => PolymerCrypto.decryption(item.myinfo.uinfin) === owner.myinfo.uinfin)){
          let relationshipWithOwner = owner.relationship_with_owner;
          const isProposed = owner.structure_status === StructureStatusEnum.incoming || owner.structure_status === StructureStatusEnum.retaining;
          if(allowBypass35YearsOldCheck && !relationshipWithOwner && isProposed){
            relationshipWithOwner = "SO";//bypass backend check
          }
          owners.push(new Owner({
            structure_status: owner.structure_status ? owner.structure_status : StructureStatusEnum.outgoing,
            own_property: owner.own_property,
            children_care_and_control: owner.children_care_and_control,
            relationship_with_owner: relationshipWithOwner,
            myinfo: new MyInfo({
              uinfin: PolymerCrypto.encryption(owner.myinfo.uinfin),
              name: owner.myinfo.name,
              dob: owner.myinfo.dob,
              residential_status: owner.myinfo.residential_status,
              marital_status: owner.myinfo.marital_status ? owner.myinfo.marital_status : MaritalStatusEnum.single
            }),
          }))
       }
    }    

    const allOccupiers = householdFormValues.incoming_occupiers.concat(householdFormValues.occupiers);
    const occupiers: Occupier[] = [];
    for(const occupier of allOccupiers){
      if(!occupiers.some(item => PolymerCrypto.decryption(item.myinfo.uinfin) === occupier.myinfo.uinfin)){
        occupiers.push(new Occupier({
          structure_status: occupier.structure_status ? occupier.structure_status : StructureStatusEnum.outgoing,
          own_property: occupier.own_property,
          relationship_with_owner: occupier.relationship_with_owner,
          myinfo: new MyInfo({
            uinfin: PolymerCrypto.encryption(occupier.myinfo.uinfin),
            name: occupier.myinfo.name,
            dob: occupier.myinfo.dob,
            residential_status: occupier.myinfo.residential_status,
            marital_status: occupier.myinfo.marital_status ? occupier.myinfo.marital_status : MaritalStatusEnum.single,
          }),
        }))
      }
    }

    return {occupiers: occupiers, owners: owners}
  },[householdFormValues, reasonValues])
  
  const saveDraft = useCallback(async(requiredAlert: boolean) => {
    setIsSavingDraft(true);
    let applicationForm = new ApplicationStep1({ reason: reasonValues, household: householdFormValues });
    let response;
    if(isValueChanged){
      const newStartForm = new ApplicationStart({...startApplicationFormData, polymer_stage: "A1"});
      const newStep1Form = applicationForm;
      newStep1Form.household.owners = newStep1Form.household.owners.map(item => new Owner({...item, myinfo: new MyInfo({...item.myinfo, mobile_no: "", email: ""})}));
      newStep1Form.household.incoming_owners = newStep1Form.household.incoming_owners.map(item => new Owner({...item, myinfo: new MyInfo({...item.myinfo, mobile_no: "", email: ""})}));
      newStep1Form.household.occupiers = newStep1Form.household.occupiers.map(item => new Occupier({...item, myinfo: new MyInfo({...item.myinfo, mobile_no: "", email: ""})}));
      newStep1Form.household.incoming_occupiers = newStep1Form.household.incoming_occupiers.map(item => new Occupier({...item, myinfo: new MyInfo({...item.myinfo, mobile_no: "", email: ""})}));
      const newStep2Form = new ApplicationStep2({...application2FormData, new_loan_type: undefined});
      const newStep3Form = new ApplicationStep3();
      const newStep4Form = new ApplicationStep4();
      const newStep5Form = new ApplicationStep5();
  
      AppDispatch(updateFormDataStart(newStartForm));
      AppDispatch(updateFormDataStep2(newStep2Form));
      AppDispatch(updateFormDataStep3(newStep3Form));
      const { file_items } = applicationStep4FormData;
      await Helpers.deleteDocumentsFromDB(file_items, loginUser?.uinfin ??'', singpassToken ?? '', applicationId ?? '');
      AppDispatch(updateFormDataStep4(newStep4Form));
      AppDispatch(updateFormDataStep5(newStep5Form));
      response = await performSaveDraftManual({applicationStart: startApplicationFormData, applicationStep1: newStep1Form, applicationStep2: newStep2Form, applicationStep3: newStep3Form, applicationStep4: newStep4Form, applicationStep5: newStep5Form, applicationId, singpassToken}, 1);
    }else{
      response = await performSaveDraft(applicationForm, 1, applicationId, singpassToken);
    }
    AppDispatch(updateFormData(applicationForm));
    if(requiredAlert){
       setSaveDraftSuccess(response);
    }
    setIsSavingDraft(false);
  }, [reasonValues, householdFormValues, startApplicationFormData, application2FormData, performSaveDraft, performSaveDraftManual, applicationId, singpassToken, isValueChanged])

  const eligibilityChecking = useCallback(async () => {
    let applicationForm = new ApplicationStep1({ reason: reasonValues, household: householdFormValues });

    // Reset eligibility state at the start of each check
    setIsEligible(undefined);
    setIsEligibleMsg('');
    setForceError(false);
    
    if (!isBtnValid) {
      console.log(
        "DEBUG reasonFormValid && householdFormValid && holdingFormValid && householdLogic && !allSprHasPropertyLogic",
        reasonFormValid,
        householdFormValid,
        holdingFormValid,
        householdLogic,
        !allSprHasPropertyLogic
      );

      // Send debug log to server when user is blocked at eligibility check
      try {
        const debugFieldTypes = {
          have_final_judgement: { value: reasonValues.have_final_judgement, type: typeof reasonValues.have_final_judgement },
          submit_content: { value: reasonValues.submit_content, type: typeof reasonValues.submit_content },
          change_ownership_reason: reasonValues.change_ownership_reason,
          reason: reasonValues.reason,
        };
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
          application_uuid: `${loginUser?.uinfin} - hdb_ref: ${hdbRef}`,
          message: `[Polymer FE -> Check Eligibility Blocked (isBtnValid=false)] HDBRef: ${hdbRef}, UIN: ${loginUser?.uinfin}, ` +
            `reasonFormValid: ${reasonFormValid}, householdFormValid: ${householdFormValid}, holdingFormValid: ${holdingFormValid}, ` +
            `householdLogic: ${householdLogic}, allSprHasPropertyLogic: ${allSprHasPropertyLogic}, ` +
            `fieldTypes: ${JSON.stringify(debugFieldTypes)}`,
        });
      } catch (_logError) {
        console.log("Failed to send eligibility blocked debug log.");
      }

      setForceError(true);
      setIsEligibleMsg("Please ensure all required fields are filled in correctly.");
      return;
    }

    // Await saveDraft before eligibility check (only for valid forms)
    await saveDraft(false);
    
    if (!isCheckingEligibility) {
      setIsCheckingEligibility(true);
      modalRef?.current?.setIsOpen(false);
      
      try {
        const res = await step1SchemeCheckingEligibility(
          applicationForm,
          loginUser?.uinfin ?? "",
          startApplicationFormData.selected_hdb_property?.flat_type,
          reasonValues.check_mop_status,
          currentHoldingType,
          hasExecutorAdministrator
        );
        
        if (!res?.eligible) {
          try {
            await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
              application_uuid: `${loginUser?.uinfin} - hdb_ref: ${hdbRef}`,
              message: `[Polymer FE -> Check Eligibility Button Step 1 ] HDBRef: ${hdbRef}, UIN: ${loginUser?.uinfin} ${JSON.stringify({ ...applicationForm, eligibility_fail_message: res?.debug ? res?.debug : res?.message })}`,
            });
          } catch (error) {
            console.log("Submit eligibility error log to backend failed.");
          } finally {
            setIsEligible(res?.eligible ?? false);
            setIsEligibleMsg(res?.message ?? "");
            setIsCheckingEligibility(false);
          }
        } else {
          //  if eligibility passed in frontend, call backend for another check
          try {
            const findCor = ChangeOwnershipReasonCode.find((item) => item.change_ownership_reason_value === reasonValues.change_ownership_reason);
            const corCode = findCor?.code ?? reasonValues.change_ownership_reason;

            const ownersAndOccupiers = getOwnersAndOccupiersForCheck();
            const eligibilityObj = new Eligibility({
              uinfin: PolymerCrypto.encryption(loginUser?.uinfin),
              change_ownership_reason: corCode,
              owners: ownersAndOccupiers.owners,
              occupiers: ownersAndOccupiers.occupiers,
              hdb_ref: startApplicationFormData?.selected_hdb_property?.hdb_ref,
            });
            const eligibilityCheckResult = await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_CheckEligibility, eligibilityObj);
            if (eligibilityCheckResult.status === 200) {
              setIsEligible(eligibilityCheckResult?.data?.eligible);
              setIsEligibleMsg(eligibilityCheckResult?.data?.message);
            } else {
              console.log("not 200");
            }
          } catch (error) {
            console.log("/application/checkEligibility API failed", error);
            setIsEligible(false);
            setIsEligibleMsg("Please try again later.");
            try {
              await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
                application_uuid: `${loginUser?.uinfin} - hdb_ref: ${hdbRef}`,
                message: `[Polymer FE -> Check Eligibility Button Step 1 -> checkEligibility API Failed] HDBRef: ${hdbRef}, UIN: ${loginUser?.uinfin}, Error: ${error}`,
              });
            } catch (logError) {
              console.log("Failed to log eligibility error", logError);
            }
          } finally {
            setIsCheckingEligibility(false);
          }
        }
      } catch (error) {
        // Catch any unhandled errors from step1SchemeCheckingEligibility to ensure isCheckingEligibility is always reset
        console.log("Eligibility check failed with unexpected error:", error);
        setIsEligible(false);
        setIsEligibleMsg("Please try again later.");
        const thrown = error instanceof Error
          ? `${error.name}: ${error.message}\n${error.stack ?? ""}`
          : String(error);
        const household = applicationForm.household;
        const structure = `owners=${household?.owners?.length ?? "missing"} incoming_owners=${household?.incoming_owners?.length ?? "missing"} occupiers=${household?.occupiers?.length ?? "missing"} incoming_occupiers=${household?.incoming_occupiers?.length ?? "missing"} reason=${reasonValues.change_ownership_reason}`;
        try {
          await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
            application_uuid: `${loginUser?.uinfin} - hdb_ref: ${hdbRef}`,
            message: `[Polymer FE -> Check Eligibility Button Step 1 -> unexpected error] HDBRef: ${hdbRef}, UIN: ${loginUser?.uinfin}, ${structure}, Error: ${thrown}`,
          });
        } catch (logError) {
          console.log("Failed to log eligibility error", logError);
        } finally {
          setIsCheckingEligibility(false);
        }
      }
    }
  }, [
    reasonValues,
    householdFormValues,
    performSaveDraft,
    applicationId,
    singpassToken,
    isBtnValid,
    isCheckingEligibility,
    reasonFormValid,
    householdFormValid,
    holdingFormValid,
    householdLogic,
    allSprHasPropertyLogic,
    loginUser?.uinfin,
    startApplicationFormData.selected_hdb_property?.flat_type,
    startApplicationFormData.selected_hdb_property?.hdb_ref,
    currentHoldingType,
    getOwnersAndOccupiersForCheck,
    hdbRef,
    hasExecutorAdministrator,
    saveDraft,
    modalRef
  ]);

  const proceedNext = useCallback(async() =>{
    //save draft will be done when check eligibility
    AppDispatch(updateStageAStep1(true));
    navigate('/application-coo/stage-a/financing');
  }, [AppDispatch, navigate]);

  const saveDraftLeavePage = useCallback(async()=>{
    await saveDraft(false);
  },[navigate, saveDraft])
  const toggleBackConfirmationModal = useCallback(() => {
    const currentTimeString = moment().format('yyyy-MM-DD HH:mm:ss');
    const alreadyTriggered = sessionStorage.getItem("back_triggered");
    if (
      alreadyTriggered !== "true" &&
      backTriggeredSlice.is_back_triggered && 
      backConfirmationModalOpen === false &&
      (backTriggeredSlice.last_back_triggered_time === "" ||
        moment(currentTimeString).diff(moment(backTriggeredSlice.last_back_triggered_time), "seconds") >= 600)
    ) {
      AppDispatch(setLastBackTriggeredTime(currentTimeString));
      AppDispatch(setBackTriggered(false));
      setBackConfirmationModalOpen((prev) => !prev);
      sessionStorage.setItem("back_triggered", "true");
    }else{
      setBackConfirmationModalOpen(false);
    }
  }, [backConfirmationModalOpen, backTriggeredSlice]);

  useEffect(() => {
      if(saveDraftSuccess){
          setTimeout(() => {
              setSaveDraftSuccess(false);
          }, 3000)
      }
  }, [saveDraftSuccess])
  
  const reasonSegmentsFormHandler = useCallback((value: string | boolean | string[] | undefined, name: string) => {
    reasonSetFormValue({ [name]: value });
    if(name === 'submit_content' && value === true) {
      reasonSetFormValue({ ["registrar_uinfin"]: "" });
    }
  }, [reasonSetFormValue, reasonValues])

  const handleHouseholdValueChange = useCallback((name: string) => (value: string | boolean) => {
    householdSetFormValue({ [name]: value })
  },[householdSetFormValue, householdFormValues])

  const openLeavePageModal = useCallback(() => {
      AppDispatch(setLeavePageModalOpen(true));
      AppDispatch(setNavigatingValue('/'));
  },[])

  const handleSaveDraft = useCallback(() => {
      saveDraft(true);
  }, [saveDraft])

  const removeApplication = useCallback(async () => {
    if(applicationId){
      try {
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken)
          .post(`${API_ApplicationRemove}/${applicationId}`)
          .then((res) => res.data);
      } catch (error) {
        console.log(error);
      }
    }
  }, [singpassToken, applicationId, loginUser]);


    /**
   * Note : This function is to remove proposed, and to add new owners due to different fields.
   */
  const isReasonChangeFromOthersToDivorce = useCallback((new_reason:ReasonEnum)=>{
    if(reasonValues.reason !== new_reason && new_reason === ReasonEnum.marital_status_reason_value){
      let cloneValue = cloneDeep(holdingFormValues);
      const formattedOwners = cloneValue.holding_owners.map(e=>{
        return {...e, is_proposed: false};
      });
      const formattedOccupiers = cloneValue.holding_occupiers.map(e=>{
        return {...e, is_proposed: false};
      });
      
      holdingSetFormValue(new HoldingFormData({
        holding_owners    : [...formattedOwners],
        holding_occupiers : [...formattedOccupiers]
      }))
      ////! Solution 2 = clear all
      // holdingSetFormValue(new HoldingFormData({
      //   holding_owners    : [],
      //   holding_occupiers : []
      // }))
      householdSetFormValue(new HouseholdFormData({...householdFormValues, incoming_owners:[], incoming_occupiers:[]}))
    }
  },[holdingFormValues, holdingSetFormValue, householdFormValues, householdSetFormValue, reasonValues.reason])

  const toolTipContent = <>
    <p>Owners of private property or owners who have disposed of a private property within the last 15 months may take over the ownership of an HDB flat if they meet the following criteria:</p>
    <ul>
      <li>The existing flat owner has fulfilled the requisite occupation period</li>
      <li>At least 1 of the proposed owners is a Singapore Citizen</li>
      <li>All proposed owners and listed occupiers must continue to live in the flat upon the change in flat ownership</li>
    </ul>
  </>

  const handleReasonSetFormValue = (data: any) => {
    reasonSetFormValue(data);
    isReasonChangeFromOthersToDivorce(data.reason);
  }

  const isRegistarSelectionRequired = useMemo(() => {
    if (reasonValues.submit_content) {
      return false;
    }

    if (reasonValues.change_ownership_reason !== OwnershipReasonEnum.divorce) {
      return false;
    }

    return !!modalRef.current?.items && modalRef.current.items.length > 0
  }, [reasonValues, modalRef])

  const handleCompleteClick = useCallback(async () => {
    if (isRegistarSelectionRequired) {
      modalRef.current?.setIsOpen(true);
    } else {
      eligibilityChecking();
    }
  }, [eligibilityChecking, isRegistarSelectionRequired, modalRef]);

  const setOutgoingOwnerRepresented = useCallback((owner: Owner) => {
    reasonSetFormValue({...reasonValues, registrar_uinfin: owner.myinfo.uinfin})
  }, [reasonValues, reasonSetFormValue])

  return (
    <ApplicationCooLayout>
      <div className='polymer-application-coo__wrapper'>
        <TextSubheader
          subheaderMain="Stage A: Start Application"
          subheaderSub={startApplicationFormData.selected_hdb_property?.address}
          paddingLeftRight={42}
        />
        <Stepper activeStep={activeStep} items={stepperItems} style={{ margin: "62px auto" }} />

        <div className='d-flex justify-content-center'>
          <SectionCard
            onClick={toggleBackConfirmationModal}
            disabled={isCheckingEligibility}
            className='flex-fill'
            activeStep={activeStep}
            stepperItems={stepperItems}
            titleChildren={
              <P2TextDescription title={stepperItems[activeStep - 1]?.title} />
            }
            contentChildren={
              <div>
                <div className='px-4'>
                  <P2TextDescription color='#000' title={"Change in Family Circumstances"} description={"Please select a reason for a change in flat ownership by choosing one of the options below."} />

                  <ReasonDropdown reasonValues={reasonValues} reasonSetFormValue={handleReasonSetFormValue}/>
                  <ReasonSegments currentOwners={householdFormValues.owners} errors={reasonErrors} values={reasonValues} ReasonSegmentsFormHandler={reasonSegmentsFormHandler} setIsCheckingEligibility={setIsCheckingEligibility} loginUserStructureStatus={loginUserStructureStatus} currentHoldingType={currentHoldingType} forceError={forceError} financialHardshipAdditionalLogic={financialHardshipAdditionalChecking}/>
                </div>

                {ownerStructureFormChecking() && <>
                  <HouseholdStructure 
                    reasonValues={reasonValues} 
                    householdFormValues={householdFormValues} 
                    householdSetFormValue={householdSetFormValue}
                    holdingFormValues={holdingFormValues} 
                    holdingFormErrors={holdingFormErrors} 
                    holdingSetFormValue={holdingSetFormValue} 
                    currentOwnerMyInfoData={currentOwnerMyInfoData}
                    retrieveFromMyInfo={retrieveFromMyInfo}
                    loginUserStructureStatus={loginUserStructureStatus}
                    forceError={forceError}
                  />
                  <Separator variant='solid' style={{ margin: "32px 0" }} />
                  <div className='px-4'>
                    <P2TextDescription required color='#000' title='Declaration in Ownership of Private Property' />
                    <div style={{marginTop:32}}>
                      <RadioGroup style={{marginTop:32}} hasTooltip tooltipContent={toolTipContent} required label='Does any of the proposed owners own or have an interest in a private property (including properties outside of Singapore)?' layout='default' items={Radio_Has_Property} value={householdFormValues.check_has_private_property} onItemSelect={handleHouseholdValueChange("check_has_private_property")}/>
                      {allSprHasPropertyLogic && householdFormValues.check_has_private_property && 
                        <div style={{marginTop:32}} >
                          <InfoCard 
                            className="polymer-alert-card" 
                            style={{backgroundColor: "#FEF0F0", color: "#981B25"}}  
                            description={
                              <div>As the proposed household are all SPRs, all the proposed owners are not allowed to have an interest or own any private properties.</div>
                            }
                          icon={<DangerCircle />}/>
                        </div>
                      }
                      {householdFormValues.check_has_private_property ?
                        <div style={{ marginTop: 32 }}>
                          <P2Alert
                            variant={"warning"}
                            text={
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: 16,
                                  color: "#981B25",
                                  fontWeight: 500,
                                }}
                              >
                                <span style={{ fontWeight: 700 }}>Note: </span>
                                Please note that for incoming owners with private property ownership, the flat may be subjected to revision of S&CC rebates and/ or IRAS’ Property Taxes. Proposed owner(s)’ eligibility for any government-announced rebates (e.g. U-Save, service & conservancy rebates) will be assessed by the respective organisation(s) based on the proposed household structure.
                              </p>
                            }
                          />
                        </div> : null
                      }
                    </div>
                  </div>
                </> 
                }

              </div>
            }
          />
        </div>

        <Separator style={{ margin: "32px 42px" }} />

        <div className='polymer-shared-alert-container'>          
          {isEligible === true && (
            <div style={{ marginTop: 24, marginBottom: 24 }}>
              <P2Alert
                variant={"success"}
                text={`Based on the information you have provided above, you are eligible to proceed with the application for Change in Flat Ownership, ${
                  reasonValues.check_mop_status === MopCheckStatusEnum.E
                    ? "subject to further checks on the occupation period of your flat and document verification by HDB."
                    : "subject to document verification by HDB."
                }`}
              ></P2Alert>
            </div>
          )}

          {saveDraftSuccess && <SaveDraftAlert/>}

          {isEligible === false && <div style={{ marginTop: 24, marginBottom: 24 }}>
            <P2Alert variant={"danger"} text={eligibleMsg}></P2Alert>
          </div>}
        </div>

        <div className='polymer-application-coo__card-button'>
          <P2ButtonGroup>
            <P2Button variant={"outline-primary"} onClick={openLeavePageModal}>Back</P2Button>
            <P2Button disabled={!reasonValues.reason || !reasonValues.change_ownership_reason || isSavingDraft} variant={"outline-primary"} onClick={handleSaveDraft}>Save as draft</P2Button>
            {(isEligible === undefined || isEligible === false) && <P2Button variant="primary-1" onClick={handleCompleteClick} disabled={isSavingDraft || isCheckingEligibility}>{isCheckingEligibility ? 'Checking' : 'Check eligibility'}</P2Button>}
            {isEligible === true && <P2Button variant="primary-1" onClick={proceedNext} disabled={false}>Next</P2Button>}
          </P2ButtonGroup>
        </div>

      <RegistrarSelectionModal
        ref={modalRef}
        outgoingOwnerRepresented={householdFormValues.owners.find(item => item.myinfo.uinfin === reasonValues.registrar_uinfin)}
        setOutgoingOwnerRepresented={setOutgoingOwnerRepresented}
        handleSubmit={eligibilityChecking}
        currentOwners={householdFormValues.owners}
      />
       
       <LeavingPageModal 
          onSubmit={saveDraftLeavePage}
          onCancel={removeApplication}
          householdFormValues={householdFormValues}
          reasonValues={reasonValues}
        /> 
      </div>

      <BackConfirmationModal onSubmit={toggleBackConfirmationModal} onClose={toggleBackConfirmationModal} isOpen={backConfirmationModalOpen}/>
    </ApplicationCooLayout>
  )
}

export default ApplicationCOOStep1
